import LocationSVG from "@design-system/ui-icons/vanilla/Location"
import { createIcon } from "../createIcon"

export const LocationIcon = createIcon(LocationSVG)
